import {BASE_URL} from './ApiEndPonts';
import axiosHttp  from './Axios';

// this file use interceptors of axios
export default class ServerCommunicationInterceptors {
  constructor() {}
  // get methos for get request
  get = async ({params = {}, endPoint = ''}) => {
    let url = `${BASE_URL}${endPoint}`;
    console.log('                            ');
    console.log('GET API URL:::', `${BASE_URL}${endPoint}`);
    return await axiosHttp.get(endPoint, {params});
  };

  // post method for post data with params
  post = async ({params = '', endPoint = '', data = {}, responseType = ''}) => {
    let url = `${BASE_URL}${endPoint}`;
    console.log(' post mehtod url', url);
    try {
      console.log('                            ');
      console.log('POST API URL:::', `${BASE_URL}${endPoint}`);
          const isFormData = data instanceof FormData;

    return await axiosHttp.post(endPoint, data, {
      headers: isFormData
        ? { "Content-Type": "multipart/form-data" } // ✅ only for file
        : { "Content-Type": "application/json" },   // ✅ normal APIs
    });

    } catch (error) {
      console.log('error POST API', error);
      throw error; // Re-throw for higher-level handling
    }

    // {params, responseType}
  };

  // put method for post data with params
  put = async ({params = '', endPoint = '', data = {}}) => {
    console.log('                            ');
    console.log( BASE_URL, endPoint, data, params);
    let url = `${BASE_URL}${endPoint}`;
    console.log('PUT API URL:::', url);
    return await axiosHttp.put(url, data, {params});
  };

  // delete method for post data with params
  delete = async ({params = '', endPoint = '', data = {}}) => {
    let url = `${BASE_URL}${endPoint}`;
    console.log('                            ');
    console.log('DELETE API URL:::', url);
    return await axiosHttp.delete(url, data, {params});
  };

  patch = async ({
    params = '',
    endPoint = '',
    data = {},
    responseType = '',
  }) => {
    let url = `${BASE_URL}${endPoint}`;
    console.log('                            ');
    console.log('POST API URL:::', `${BASE_URL}${endPoint}`);
    return await axiosHttp.patch(url, data, {params, responseType});
    try {
      console.log('POST API URL:::', `${BASE_URL}${endPoint}`);
      return await axiosHttp.patch(url, data, {params, responseType});
    } catch (error) {
      throw error;
    }
  };
}
